import { Prefs } from "~/alias/prefs";
import { License } from "~/picreplacement/check";
import * as ewe from "@eyeo/webext-ad-filtering-solution";
export async function getFacts() {
    var _a, _b, _c;
    await Promise.all([Prefs.untilLoaded, License.ready()]);
    const userFilters = await ewe.filters.getUserFilters();
    return {
        hasPremium: await License.isActiveLicense(),
        installDate: Prefs.get("installDate"),
        blockedCount: Prefs.get("blocked_total"),
        reverseTrialStartDate: Prefs.get("reverse_trial_start_date"),
        lastBlockthroughTagDate: Prefs.get("lastBlockthroughTagDate"),
        lastBaitBlockedDate: Prefs.get("lastBaitBlockedDate"),
        partnerExtensionCoinstalled: ((_c = (_b = (_a = Prefs.get("partnerExtensionFound")) === null || _a === void 0 ? void 0 : _a.extesnionsIdsFound) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0,
        customFiltersCount: userFilters.filter((f) => f.enabled === true).length,
    };
}
export function start() {
    License.licenseNotifier.on("license.status.changed", ewe.remoteConfig.updateFacts);
    Prefs.on("installDate", ewe.remoteConfig.updateFacts);
    ewe.subscriptions.onAdded.addListener(ewe.remoteConfig.updateFacts);
    ewe.subscriptions.onChanged.addListener(async () => {
        await ewe.remoteConfig.updateFacts();
    });
    ewe.subscriptions.onRemoved.addListener(ewe.remoteConfig.updateFacts);
}
